import { DateInputForm } from "@styleguide";
import { useMemo } from "react";
import { type Control, useWatch } from "react-hook-form";
import { jobSituations } from "../../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormEndOfContractProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormEndOfContract = ({ control }: IModalActionFormEndOfContractProps) => {
  const jobSituation = useWatch({
    control,
    name: "jobFollowUp.jobSituation",
  });

  const displayEndOfContract = useMemo(
    () => Boolean(jobSituations.find((option) => option.value === jobSituation)?.endOfContract),
    [jobSituation]
  );

  if (!displayEndOfContract) {
    return null;
  }
  return (
    <DateInputForm
      control={control}
      name="jobFollowUp.endOfContract"
      label="Date de fin de contrat *"
      TextFieldProps={{ size: "small" }}
    />
  );
};
